export default __webpack_public_path__ + "media/images/logo/media/bs11-3cd39e73d17664061e8817408f19ac50.png";